import { OfficeDTO } from '@iota/iota-management-portal-v4-client';
import { createAction, props } from '@ngrx/store';
import { UpdateOfficeRequest } from '@iota/inh-core-v1-management-client';

export enum OfficeActionTypes {
    LoadAllOffices = '[Office] LoadAllOffices',
    LoadAllOfficesSuccess = '[Office] LoadAllOfficesSuccess',

    LoadOfficesFailure = '[Office] Load Offices Failure',

    ReloadOffice = '[Office] ReloadOffice',
    ReloadOfficeSuccess = '[Office] ReloadOfficeSuccess',
    ReloadOfficeFailure = '[Office] ReloadOfficeFailure',

    OfficeActionFailure = '[Office] OfficeActionFailure',

    CreateOffice = '[Office] CreateOffice',
    CreateOfficeSuccess = '[Office] CreateOfficeSuccess',
    UpdateOffice = '[Office] UpdateOffice'
}
export const LoadAllOffices = createAction(OfficeActionTypes.LoadAllOffices);
export const LoadAllOfficesSuccess = createAction(OfficeActionTypes.LoadAllOfficesSuccess, props<{ offices: OfficeDTO[] }>());

export const CreateOffice = createAction(OfficeActionTypes.CreateOffice, props<{ office: OfficeDTO }>());
export const CreateOfficeSuccess = createAction(OfficeActionTypes.CreateOfficeSuccess, props<{ officeId: string }>());
export const UpdateOffice = createAction(OfficeActionTypes.UpdateOffice, props<{ id: string; request: UpdateOfficeRequest }>());

export const OfficeActionFailure = createAction(OfficeActionTypes.OfficeActionFailure, props<{ error: any }>());

export const LoadOfficesFailure = createAction(OfficeActionTypes.LoadOfficesFailure, props<{ error: any }>());

export const ReloadOffice = createAction(OfficeActionTypes.ReloadOffice, props<{ officeId: string }>());
export const ReloadOfficeSuccess = createAction(OfficeActionTypes.ReloadOfficeSuccess, props<{ office: OfficeDTO }>());
export const ReloadOfficeFailure = createAction(OfficeActionTypes.ReloadOfficeFailure, props<{ error: any }>());
